<template>
    <vue-select
        v-bind="$attrs"
        v-on="$listeners"
        :options="options"
    >
        <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
                Hittade inga resultat på <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Sök på skrivare</em>
        </template>
    </vue-select>
</template>
<script>
import VueSelect from '@components/Wrappers/VueSelect';
import apiClient from '@services/ApiClient';
import Cache from '@services/Cache';

export default {
    name: 'LabelPrinterFilter',
    components: {
        VueSelect,
    },
    data() {
        return {
            options: [],
        };
    },
    created() {
        this.getOptions();
    },
    methods: {
        async getOptions() {
            let options = Cache.get('label-printer-list');
            if (!options) {
                await apiClient.get('/vue/shipping/ntaps/printers')
                    .then((response) => {
                        options = response.data;
                        Cache.set('label-printer-list', response.data, 60 * 5 * 1000);
                    });
            }

            if (options) {
                this.options = options.map((item) => ({
                    id: item.tag,
                    label: item.name,
                    ...item,
                }));
            }
        },
    },
};
</script>
